import { defineOperationManifest } from "../define"

export const productsDetectMetadataManifest = defineOperationManifest({
	type: "products.detect-metadata",
	ability: "ai.detect-allergens",
	usageAbility: "ai.detect-allergens",
	bocLabelKey: "operations.boc.types.productsDetectMetadata",
})
